import {AccountsService} from "../../Http/Accounts/AccountsService";
import {WidgetsService} from "../../Http/Widgets/WidgetsService";
import template from "./accounts-details-non-hsa.html"

ko.components.register('accounts-details-non-hsa', {
    template: template,
    viewModel: {
        createViewModel: function (params, componentInfo, widgetInfo) {
            return new AccountsDetailsNonHsaModel(widgetInfo.updateHeight);
        }
    }
});



function AccountsDetailsNonHsaModel(updateHeight) {
    const self = this;
    $.cdh.extensions.profile.ProfileItemBase.call(self, updateHeight);

    let accountId = $.cdh.helper.urlParam('accountId');
    let options = $.cdh.helper.urlParam('options');
    let page = $.cdh.helper.urlParam('page');

    self.paramAccountId = accountId;
    self.paramOptions = options;

    self.isPreferences = page === 'Preferences';
    self.isSubmitClaim = page === 'SubmitClaim';

    self.accountId = accountId;
    self.options = options;
    self.updateHeight = updateHeight;

    self.planYears = ko.observableArray([]);

    self.selectedYear = ko.observable();

    self.accountsService = new AccountsService();

    self.dependents = ko.observableArray([]);

    self.callComputed = ko.observable();
    self.HasOnlyOneAccount = ko.observable(false);
    self.allowAddClaim = ko.observable($.cdh.employee.allowEnterClaimRequests());

    let $window = $(window);
    self.width = ko.observable($window.width());
    $window.resize(function () {
        self.width($window.width());
    });

    self.isMobileMode = ko.pureComputed(function () {
        return $.cdh.isMobile && self.width() < 768;
    });

    self.extendedDetails = new $.cdh.get.accounts.detailsNonHsa(accountId, options);
    self.dependentsRequest = new $.cdh.get.accounts.dependentsNonHsa(accountId, options);
    self.account = ko.observable(null);

    $(document.body).on('mouseenter focus', 'div.js-tooltip', (event) => {
        var $element = $(event.currentTarget);
        var optionsContainer = $element.find('.tool_tip_data');
        optionsContainer.addClass('data_opened');
        if ($element[0].getBoundingClientRect().bottom + 25 + optionsContainer.height() > $(window).innerHeight()) {
            optionsContainer.addClass('inverted');
        } else {
            optionsContainer.removeClass('inverted');
        }
    });

    $(document.body).on('mouseleave blur', 'div.js-tooltip', (event) => {
        var $element = $(event.currentTarget);
        var optionsContainer = $element.find('.tool_tip_data');
        optionsContainer.removeClass('data_opened');
    });

    self.IntervalTracker = ko.pureComputed(function () {
        return new $.cdh.get.accounts.intervalTracker(accountId, self.selectedYear());
    });
    //self.FieldsAliases = ko.observable();

    self.selectedInterval = ko.observableArray();
    self.IntervalTrackerData = ko.observableArray();

    self.planAutoPaymentPreferenceEnabled = ko.pureComputed(function () {
        if (!self.extendedDetails.hasData())
            return false;

        return self.extendedDetails.data().PlanAutoPaymentPreferenceEnabled;
    });

    self.planAutoReimbursementPreferenceEnabled = ko.pureComputed(function () {
        if (!self.extendedDetails.hasData())
            return false;

        return self.extendedDetails.data().PlanAutoReimbursementPreferenceEnabled;
    });

    self.showPreference = ko.pureComputed(function () {
        return (self.planAutoPaymentPreferenceEnabled() && $.cdh.employee.allowAutoPaymentPreference()) || (self.planAutoReimbursementPreferenceEnabled() && $.cdh.employee.allowAutoReimbursementPreference());
    });

    self.annualContributionChartData = ko.pureComputed(function () {
        if (!self.account() || !self.extendedDetails.hasData()) {
            return null;
        }

        return {
            AccountType: self.account().AccountType,
            ContributionsYTD: self.extendedDetails.data().ContributionsYTD,
            RemainingContributions: self.extendedDetails.data().RemainingContributions
        }
    });

    self.submitClaimBuilder = function () {
        let model = new $.cdh.models.SubmitClaimWidgetModel(self.updateHeight, self.updateHeight);
        model.forAccountId = accountId;
        model.title = $.cdh.languageConstant.getConstant('AccountDetail.lblSubmitClaim');
        return model;
    };

    self.preferenceModelBuilder = function () {
        return new $.cdh.models.ClaimsAutoPaymentPrefs(self);
    };

    self.isTypeClassFsaOrOther = ko.pureComputed(function () {
        if (!self.account())
            return false;

        return self.account().AccountTypeClass === $.cdh.enums.accountTypeClass.fsa ||
            self.account().AccountTypeClass === $.cdh.enums.accountTypeClass.other;
    });

    self.isTypeClassFsa = ko.pureComputed(function () {
        if (!self.account())
            return false;

        return self.account().AccountTypeClass === $.cdh.enums.accountTypeClass.fsa;
    });

    self.isTypeCra = ko.pureComputed(function () {
        if (!self.account())
            return false;

        return self.account().IsCra;
    });

    self.extendedDetails.state.subscribe(updateHeight);

    self.anyDeps = ko.pureComputed(function () {
        if(self.account().HideFamilyDetails)
            return false;

        if (!self.extendedDetails.hasData())
            return false;

        return self.extendedDetails.data().AnyDependentAvailable;
    });

    self.planDescAvailable = ko.pureComputed(function () {
        return $.cdh.helper.isValueSet(self.account().PlanUsageDescription);
    });
    self.isPlanDescVisible = ko.observable(false);
    self.togglePlanDesc = function () {
        self.isPlanDescVisible(!self.isPlanDescVisible());
    };

    self.accountDetails = ko.observable();
    self.isHRX = ko.observable(false);
    self.extendedDetails.load().done(function (details) {
        if (details.AnyDependentAvailable) {
            self.dependentsRequest.load().done(function (dependents) {
                ko.utils.arrayPushAll(self.dependents, dependents);
                updateHeight();
            });
        }

        self.accountDetails(details);
        if (details.AccountType === "HRX") {
            self.isHRX(true);
        }
    });

    self.rewardsUrl = ko.observable();
    self.widgetsService = new WidgetsService();
    self.widgetsService.getRewardsUrlAsync().then(msg => {
        self.rewardsUrl(msg.message);
    });

    self.IntervalChanged = function () {
        const balances = getUpdatedBalances(self.selectedInterval());
        let balanceValtoDisplay = balances.intervalBalance;
        if (!self.isLimitTypeTotalContributed(self.selectedInterval().LimitType) && balances.totalAccountBalance < balances.intervalBalance) {
            balanceValtoDisplay = balances.totalAccountBalance;
        }
        let _account = {
            currentInvervalPeriod: ko.observable(self.selectedInterval().IntervalPeriod),
            currentIntervalBalance: ko.observable(balances.totalAccountBalance),
            currentIntervalDeposits: ko.observable(self.selectedInterval().IntervalDeposits),
            currentIntervalDisbursed: ko.observable(self.selectedInterval().TotalSpent),
            currentIntervalRemaining: ko.observable(balances.intervalBalance),
            currentSpendingLimit: ko.observable(balances.spendingLimit),
            balanceToDisplay: ko.observable(balanceValtoDisplay)
        }
        
        if (self.account()) {
            $.extend(self.account(), _account);
            self.account(self.account());
            updateHeight();
        }
    }

    self.isLimitTypeTotalContributed = function (limitType) {
        const validTypes = [
            "Both Deposits and Transactions - Total Contributed",
            "Transactions Only - Total Contributed"
        ];
        return validTypes.includes(limitType);
    };

    self.isLimitTypeDepositOnly = function (limitType) {
        return limitType === "Deposits Only";
    };

    function getUpdatedBalances(interval) {
        let totalAccountBalance = interval.TotalAccountBalance;
        let intervalBalance = interval.SpendingLimitRemaining;
        let spendingLimit = interval.SpendingLimitForTheInterval;

        if (self.isLimitTypeTotalContributed(interval.LimitType)) {
            totalAccountBalance = "0.00";  // here TotalAccountBalance is -1, so assign it to 0
        }
        else if (self.isLimitTypeDepositOnly(interval.LimitType)) {
            intervalBalance = totalAccountBalance; // here SpendingLimitRemaining is -1, so use TotalAccountBalance
            spendingLimit = "0.00";
        }

        return {
            totalAccountBalance,
            intervalBalance,
            spendingLimit
        };
    }

    function loadAccount() {
        self.accountsService.countCurrentAsync().then(count => self.HasOnlyOneAccount(count === 1));
        var monthIntervalVal = '1';
        var quarterIntervalVal = '3';

        self.accountsService.byAccountIdAsync(self.accountId).then(account => {
            if (account) {
                self.allowAddClaim(account.AddClaimAllowed && account.ManualClaimsEnabled);
            }

            if (self.isSubmitClaim && self.allowAddClaim() && $.cdh.tpa.useExpensePortal) {
                document.location.href = $.cdh.routes.predefined.claims.portal;
            }


            account.IsMonthOrQuarter = ko.observable(false);
            account.IsMonthOrQuarter = (account.SpendingLimitPeriod == monthIntervalVal || account.SpendingLimitPeriod == quarterIntervalVal);

            return account;
        }).then(function (account) {
            self.fetchDataForYear(account)
        });
    }

    self.getIntervalTrackerYear = function (planEndDate) {
        const currentYear = new Date().getFullYear();
        const planYear = planEndDate ? new Date(planEndDate).getFullYear() : currentYear;
        return planYear >= currentYear ? currentYear : planYear;
    }

    self.yearChanged = function () {
        $(window).scrollTop(0);
        loadAccount()
    };

    self.fetchDataForYear = function (account) {
        var monthIntervalVal = '1';
        var quarterIntervalVal = '3';
        account.accountIntervalType = ko.observable(false);
        account.PayrollHeader = ko.observable("Payroll Deposits YTD");
        account.currentInvervalPeriod = ko.observable(null);
        account.currentIntervalBalance = ko.observable(null);
        account.currentIntervalDeposits = ko.observable(null);
        account.currentIntervalDisbursed = ko.observable(null);
        account.currentIntervalRemaining = ko.observable(null);
        account.currentSpendingLimit = ko.observable(null);
        account.balanceToDisplay = ko.observable(null);
        if (!self.selectedYear()) {
            self.selectedYear(self.getIntervalTrackerYear(account.PlanEndDate));
        }

        account.IsFutureYearPlan = (account.AccountPlanYear === $.cdh.enums.planYear.future);
        if (account.IsMonthOrQuarter) {

            self.IntervalTracker().load().done(function (data) {
                self.IntervalTrackerData(data);
                self.planYears = (data.length > 0 && data[0].PlanYears) ? data[0].PlanYears.reverse() : [];


                if (account.AccountPlanYear === $.cdh.enums.planYear.current || account.AccountPlanYear === $.cdh.enums.planYear.previous) {
                    if (data.length) {
                        var intervalData = data[data.length - 1];

                        if (intervalData.IntervalType == monthIntervalVal || intervalData.IntervalType == quarterIntervalVal) {
                            const balances = getUpdatedBalances(intervalData);
                            account.currentInvervalPeriod(intervalData.IntervalPeriod);
                            account.currentIntervalBalance(balances.totalAccountBalance);
                            account.currentIntervalDeposits(intervalData.IntervalDeposits);
                            account.currentIntervalDisbursed(intervalData.TotalSpent);
                            account.currentIntervalRemaining(balances.intervalBalance);
                            account.currentSpendingLimit(balances.spendingLimit);
                            account.balanceToDisplay(balances.intervalBalance);
                            if (!self.isLimitTypeTotalContributed(intervalData.LimitType) && balances.totalAccountBalance < balances.intervalBalance) {
                                account.balanceToDisplay(balances.totalAccountBalance)
                            }
                            
                            if (intervalData.IntervalType == monthIntervalVal) {
                                account.PayrollHeader($.cdh.languageConstant.getConstant('AccountSummaryNonHSA.lblPayRollHeaderMonthly'));
                            }
                            else if (intervalData.IntervalType == quarterIntervalVal) {
                                account.PayrollHeader($.cdh.languageConstant.getConstant('AccountSummaryNonHSA.lblPayRollHeaderQuarterly'));
                            }
                            account.accountIntervalType(true);
                        }
                    }
                }
                /* The below code for future plans is for this below requirement:
                    * User Story 223044: [Monthly/quarterly]Payroll Deposit YTD Showing instead of MTD in Account Details page
                    * Given: I am a WCP user
                    * When: I am on Account Details screen
                    * Then: Pay roll MTD Should display in both summery & account details page 
                    * 
                    * Since the interval tracker details for Future DCA/FSN plans are not being sent in API response, validation for below code is not yet done.
                    * This needs to be validated once the WCA response has interval tracker details for future DCA/FSN plans
                    * 
                     Bug 304299: [Interval Tracker]Interval tracker feature plans graph not loading for Monthly/Quarterly
                    * Displaying $--.-- for amount fields since WCA response will be empty for interval tracker details for future plans
                */
                else if (account.AccountPlanYear === $.cdh.enums.planYear.future) {
                    account.currentInvervalPeriod(0);
                    account.currentIntervalBalance(0);
                    account.currentIntervalDeposits(0);
                    account.currentIntervalDisbursed(0);
                    account.currentIntervalRemaining(0);
                    account.currentSpendingLimit(0);
                    account.balanceToDisplay(0);

                    if (account.SpendingLimitPeriod == monthIntervalVal) {
                        account.PayrollHeader($.cdh.languageConstant.getConstant('AccountSummaryNonHSA.lblPayRollHeaderMonthly'));
                    }
                    else if (account.SpendingLimitPeriod == quarterIntervalVal) {
                        account.PayrollHeader($.cdh.languageConstant.getConstant('AccountSummaryNonHSA.lblPayRollHeaderQuarterly'));
                    }
                    account.accountIntervalType(true);
                }
            });
        }
        self.account(account);
        updateHeight();
    }

    loadAccount();

    self.updateDeductibleStatusCallback = function () {
        self.account(null);
        self.accountsService.clearCache();
        loadAccount();
    };

    self.displayAnnualElection = ko.pureComputed(function () {
        if (!self.account() || !self.extendedDetails.hasData())
            return false;

        if (self.account().HidePayrollInfoAndCharts || !self.extendedDetails.data().ShowDeadlines)
            return false;

        return true;
    });

    self.isExistActiveCarryover = ko.pureComputed(function () {
        return self.account() && self.account().ActiveCarryoverSettings;
    });

    self.sourceCarryoverAmountLabel = ko.pureComputed(function () {
        if (self.isExistActiveCarryover()) {
            return self.account().ActiveCarryoverSettings.AmountCustomLabel;
        }

        return null;
    });

    self.showDeadlines = ko.pureComputed(() => {
        if (!self.account() || !self.extendedDetails.hasData())
            return false;

        let fieldsAliases = self.account().FieldsAliases;
        return self.extendedDetails.data().ShowDeadlines &&
            (self.extendedDetails.data().ShowEligibilityDate || fieldsAliases.PlanStartDate || fieldsAliases.PlanEndDate ||
                fieldsAliases.LastDayForSpending || fieldsAliases.LastDayToSubmitClaims);
    });

    self.rolloverAmountDescription = function (rollover) {
        let details = self.extendedDetails.data();

        let appendRolloverInfo = function (rolloverInfo, result) {
            for (let i = 0; i < rolloverInfo.length; i++) {
                let info = rolloverInfo[i];

                let individualAmount = rollover.IsPrimary
                    ? info.PrimaryFundRolloverAmount
                    : info.SecondaryFundRolloverAmount;

                let individualRate = rollover.IsPrimary
                    ? info.PrimaryFundRolloverRate
                    : info.SecondaryFundRolloverRate;

                if (result) {
                    result = result + "<br/>" +
                        self.getFundRolloverDescription(individualAmount, individualRate, rollover.RolloverRule);
                } else {
                    result = self.getFundRolloverDescription(individualAmount, individualRate, rollover.RolloverRule);
                }
            }

            return result;
        };

        let result = "";

        if (details.IsHRA && details.FundRolloverInfo) {
            result = $.cdh.languageConstant.getConstant('AccountDetail.lblFamilyAmt')+":";

            if (rollover.RolloverRule != $.cdh.enums.fundRolloverTypeEnum.allFunds) {
                result = appendRolloverInfo(details.FundRolloverInfo, result);
            } else {
                result = result + "<br/>" + $.cdh.languageConstant.getConstant('AccountDetail.msgRollOverDescription1');
            }

            result = result + "<br/><br/>" + $.cdh.languageConstant.getConstant('AccountDetail.lblIndividualAmt')+":<br/>";
            result = result +
                self.getFundRolloverDescription(
                    rollover.IndividualRolloverAmount,
                    rollover.IndividualRolloverRate,
                    rollover.RolloverRule);

        } else if (!details.IsHRA && details.FundRolloverInfo) {

            if (rollover.RolloverRule != $.cdh.enums.fundRolloverTypeEnum.allFunds) {
                result = appendRolloverInfo(details.FundRolloverInfo, result);
            } else {
                result = result + $.cdh.languageConstant.getConstant('AccountDetail.msgRollOverDescription1');
            }

        } else if (details.IsHRA) {

            result = result + $.cdh.languageConstant.getConstant('AccountDetail.lblFamilyAmt') + ":<br/>";
            result = result +
                self.getFundRolloverDescription(
                    rollover.RolloverAmount,
                    rollover.RolloverRate,
                    rollover.RolloverRule) + "<br/><br/> " + $.cdh.languageConstant.getConstant('AccountDetail.lblIndividualAmt') +": <br/>";

            result = result +
                self.getFundRolloverDescription(
                    rollover.IndividualRolloverAmount,
                    rollover.IndividualRolloverRate,
                    rollover.RolloverRule);

        } else {
            result = self.getFundRolloverDescription(
                rollover.RolloverAmount,
                rollover.RolloverRate,
                rollover.RolloverRate);
        }

        return result;
    };

    self.getFundRolloverDescription = function (amount, rate, type) {
        let result = "";

        switch (type) {
            case $.cdh.enums.fundRolloverTypeEnum.allFunds:
            case $.cdh.enums.fundRolloverTypeEnum.none: {
                result = $.cdh.languageConstant.getConstant('AccountDetail.msgRollOverDescription1'); ;
                break;
            }
            case $.cdh.enums.fundRolloverTypeEnum.cap: {
                result = $.cdh.languageConstant.getConstant('AccountDetail.msgRemaingBalUpto') + $.cdh.helper.htmlFormatAmount(amount);
                break;
            }
            case $.cdh.enums.fundRolloverTypeEnum.percentage: {
                result = rate + " % " + $.cdh.languageConstant.getConstant('AccountDetail.msgPercentOfRemainingBal');
                break;
            }
            case $.cdh.enums.fundRolloverTypeEnum.capAndPercentage: {
                result = rate + "% " + $.cdh.languageConstant.getConstant('AccountDetail.msgPercentOfRemainingBalUpto') + $.cdh.helper.htmlFormatAmount(amount);
                break;
            }
        }

        return result;
    };
}


